import type { ContentUsps } from '@/scopes/prices/infrastructure/transport/types'
import type { IconGlyph } from '@sunwebgroup/ui-components'

export interface TransportSelectorMappedResponse {
  transportType: string
  outboundRoutes: RouteInfo[]
  inboundRoutes: RouteInfo[]
  tripSummary: TripSummary
  paymentMethod: {
    icon: string
    text: string
  } | null
}
export interface RouteInfo {
  id: string
  airline: Airline | null
  arrivalDate: RouteDate
  departureDate: RouteDate
  flightType: 'flexible' | 'standard' | null
  luggage: Luggage[] | null
  price: number
  route: Route
  stationName: string | null
  relatedRoutes?: RelatedInboundRoute[]
  remark?: string
  isDefault?: boolean
}
interface Luggage {
  type: string
  weight: number
}

export interface Route {
  from: {
    code: string
    name: string
  }
  to: {
    code: string
    name: string
  }
}

export interface RelatedInboundRoute extends RouteInfo {
  tripSummary: TripSummary
  priceBreakdown: PriceBreakdown
}

interface RouteDate {
  time: string
  fullDate: string
}

interface Airline {
  id: string
  name: string
}

export interface SelfDriveSelectorResponse {
  transportType: string
  tripSummary?: TripSummary
  priceBreakdown?: PriceBreakdown
  contentUsps?: ContentUsps
  paymentMethod: {
    icon: string
    text: string
  } | null
}

export interface TripSummaryItem {
  header: {
    icon: IconGlyph
    text: string
    stars?: number
  }
  extraInfo: string[]
}

export type TripSummary = TripSummaryItem[]

export interface PriceBreakdown {
  atReservation: {
    rooms: PriceItem[][]
    services: ServiceItem[]
    subtotal: number
  }
  atDestination: {
    items: ServiceItem[]
    subtotal: number
  }
  totalPrice: number
  totalGrossPrice: number
  pricePerPerson: number
  extraCostsText: {
    title: string
    text: string
  }
  usps: Usp[]
  countDown?: {
    icon: IconGlyph
    deadline: string
    text: string
  }
}

interface Usp {
  type: string
  title: string
  text?: string
}

interface PriceItem {
  price: number
  valueText: string
  description: string
  isDiscount: boolean
}

export interface ServiceItem extends PriceItem {
  header: string
}

export enum FlightType {
  Inbound,
  Outbound,
}
